import { createStores } from './store/utils';

export const marketing = createStores({
    upsellRecommendation: {
        matchId: undefined,
        marketId: undefined,
    },
});
